import styled from "styled-components";

export const ImageContainer = styled.div.attrs({ className: "mx-auto" })`
  ${({ theme }) => theme.lg`
      width: 80%;
   `}
`;
